var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-file-upload",
    {
      attrs: {
        label: _vm.$ct("images"),
        "allowed-extensions": _vm.allowedExtensions,
        "max-size": _vm.maxSize,
        disabled: _vm.disabled,
        multiple: _vm.multiple,
      },
      on: {
        input: function ($event) {
          return _vm.onInput($event)
        },
        error: function ($event) {
          return _vm.onError($event)
        },
        finished: function ($event) {
          return _vm.onFinished($event)
        },
        start: _vm.onStart,
      },
    },
    [
      _c(
        "div",
        { staticClass: "drop", class: { disabled: _vm.disabled } },
        [
          _vm.sending
            ? _c("w-progress-linear", {
                staticClass: "full inTitle",
                attrs: { color: "#1c86f0" },
              })
            : _vm._e(),
          _vm._v(" " + _vm._s(_vm.label) + " "),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }